// Contact Information related Redux Constants
export const [
  CONTACT_DETAILS,
  CONTACT_SUMMARY
] = [
  "CONTACT_DETAILS",
  "CONTACT_SUMMARY"
];
